function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { cmsActions } from '../../reducers/cms.reducer';
import SubHeaderMaterials from './SubHeaderMaterials.react';
var NavigationHeader = function NavigationHeader(_ref) {
  var route = _ref.route;
  var cmsNavigation = useSelector(function (s) {
    return s.cms.navigation || {};
  });
  var _useParams = useParams(),
    app = _useParams.app,
    itemID = _useParams.itemID;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    navArr = _useState2[0],
    setNavArr = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedArr = _useState4[0],
    setSelectedArr = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    selected = _useState6[0],
    _setSelected = _useState6[1];
  useEffect(function () {
    setNavArr(Object.values(cmsNavigation).filter(function (x) {
      return x.clientApp === app && x.navbar === 'header' && x.archived !== true;
    }));
    _setSelected(null);
  }, [app, cmsNavigation]);
  useEffect(function () {
    var tmpArr = [];
    var tmpItem = Object.values(cmsNavigation).find(function (x) {
      return x._id === itemID;
    });
    if (tmpItem) {
      tmpArr.push(tmpItem);
      var tmpParentArr = _getParent(tmpItem, null);
      if (tmpParentArr) tmpArr = [].concat(_toConsumableArray(tmpParentArr), _toConsumableArray(tmpArr));
    }
    setSelectedArr(tmpArr);
  }, [itemID]);
  useEffect(function () {
    var tmpArr = [];
    var tmpItem = Object.values(cmsNavigation).find(function (x) {
      return x._id === selected;
    });
    if (tmpItem) {
      tmpArr.push(tmpItem);
      var tmpParentArr = _getParent(tmpItem, null);
      if (tmpParentArr) tmpArr = [].concat(_toConsumableArray(tmpParentArr), _toConsumableArray(tmpArr));
    }
    setSelectedArr(tmpArr);
  }, [selected]);
  var _getParent = function getParent(item, arr) {
    if (item.parentID) {
      if (!arr) arr = [];
      var tmpItem = Object.values(cmsNavigation).find(function (x) {
        return x._id === item.parentID;
      });
      arr.unshift(tmpItem);
      if (tmpItem.parentID) _getParent(tmpItem, arr);else return arr;
    }
    return arr;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, (app === 'washplant' || app === 'materials') && /*#__PURE__*/React.createElement(SubHeaderMaterials, {
    app: app,
    navArr: navArr,
    route: route,
    selectedArr: selectedArr,
    setSelected: function setSelected(val) {
      return _setSelected(val);
    }
  }));
};
var mdtp = {
  navigationAction: cmsActions.navigation
};
export default connect(null, mdtp)(NavigationHeader);